
import { computed, defineComponent, nextTick, reactive, ref, toRefs, watch, ComputedRef } from 'vue'
import nineDirections, { getVideoPlayInfoList } from '@/api/nineDirections'
import router from '@/router/index'
import { useRoute } from 'vue-router'
import store from '@/store'
import Player from '@/components/jfschool/player.vue'
import { DownOutlined, AlignCenterOutlined, PlayCircleFilled } from '@ant-design/icons-vue'
import Nodata from '@/components/nodata.vue'
export default defineComponent({
  components: {
    Player,
    DownOutlined,
    AlignCenterOutlined,
    PlayCircleFilled,
    Nodata
  },
  setup() {
    type pageDataType = {
      videoInfo: any
      courseChapterDetailDTOList: any
      expandedKeys: string[]
      treeData: Array<any>
      activeKey: string
      introduction: any
      currentLess: any
      courseId: ComputedRef<string> | string
      lessonNo: ComputedRef<string> | string
      theme: string
      playing?: boolean
      breadcrunmb?: Array<{
        title: string
        routename: string
      }>
      videos: Array<any>
      definition?: Array<any>
    }
    const route = useRoute()
    // if (!route.query.token) {
    //   gotoClientLogin()
    // }
    const pageData: pageDataType = reactive({
      videoInfo: [],
      courseChapterDetailDTOList: [],
      expandedKeys: [],
      treeData: [],
      activeKey: '1',
      introduction: {},
      currentLess: {}, // 当前播放的视频信息
      courseId: route.query.courseNo as string,
      lessonNo: route.query.lessonNo as string,
      theme: (route.query.theme as string) || 'theme',
      playing: false,
      breadcrunmb: [],
      definition: [],
      videos: []
    })
    // pageData.courseId = computed(() => {
    //   return route.query.courseNo as string
    // })
    // watch(() => pageData.le)
    watch(
      () => [route.query.courseNo],
      () => {
        pageData.lessonNo = ''
        pageData.courseId = route.query.courseNo as string
      }
    )
    const replaceFields = reactive([
      {
        title: 'lessonName',
        children: 'lessonDetailDTOList'
      }
    ])
    function getCourseDtail() {
      nineDirections.schoolCourseLessonDetail(
        { courseNo: pageData.courseId },
        { 
          username: route.query.userName as string || '',
          token: route.query.token as string || ''  
        }
      ).then((res: any) => {
        if (!res) return
        const result = res.data || {}
        // 设置课程基本信息（shortIntroduction 取自 authorDTO.attribute）
        pageData.introduction = {
          name: result.name,
          introductionImage: result.introductionImage,
          introduction: result.introduction,
          shortIntroduction: result.authorDTO?.attribute?.shortIntroduction ?? result.shortIntroduction,
          coverImage: result.coverImage
        }
        // 处理章节和课时数据（接口字段：courseChapterDetailDTOList、lessonDetailDTOList）
        const chapterLessons = result.courseChapterDetailDTOList || []
        if (chapterLessons.length) {
          chapterLessons.forEach((item: any, n: number) => {
            const lessonList = item.lessonDetailDTOList || []
            if (lessonList.length) {
              lessonList.forEach((less: any, i: number) => {
                less.title = less.lessonName
                less.key = less.lessonNo
                less.index = i
              })
            }
            item.children = lessonList
            item.title = item.chapterName || ''
            item.key = item.chapterNo
            if (n === 0) {
              pageData.expandedKeys = [item.key]
            }
          })
        }
        pageData.treeData = chapterLessons
        if (pageData.treeData.length) {
          if (pageData.lessonNo) {
            const treeData = chapterLessons.map((item: any) => item.lessonDetailDTOList || []).flat()
            const currentless = (treeData || []).filter((item: any) => {
              return item && (item.lessonNo === pageData.lessonNo || item.chapterNo === pageData.lessonNo)
            })
            pageData.currentLess = currentless[0]
            pageData.expandedKeys = [pageData.currentLess?.chapterNo]
          } else {
            pageData.currentLess = (((chapterLessons || [])[0] || {}).lessonDetailDTOList || [])[0] || {}
          }
          getVideoUrl(pageData.currentLess)
        } else {
          pageData.videoInfo = []
          pageData.currentLess = {}
        }
      })
    }
    // 视频地址
    function getVideoUrl(subCourse: any) {
      const requestData = [
        {
          playType: 'video',
          video: {
            mediaId: subCourse.videoId
          }
        }
      ]
      getVideoPlayInfoList(requestData, {
        appcode: store.state.pcqueryInfo.appcode,
        serverId: store.state.pcqueryInfo.serverid,
        token: route.query.token as string || '',
        appVersion: store.state.pcqueryInfo.appversion,
        clientType: 'pc',
        softName: (route.query.softNameAbbr as string || 'jfztadv').toLowerCase(),
        username: route.query.userName as string || ''
      }).then((res: any) => { 
        const result = res.data || []
        if (result.length && result[0].video) {
          const videoData = result[0].video
          pageData.videos = [videoData]
          pageData.definition = []
          pageData.videoInfo = {
            playURL: videoData.url,
            duration: Math.floor(videoData.duration / 1000),
            width: videoData.width,
            height: videoData.height,
            size: videoData.size,
            coverUrl: videoData.coverUrl,
            mediaId: videoData.mediaId
          }
        } else {
          pageData.videoInfo = []
          pageData.videos = []
        }
        nextTick(() => {
          const dom: any = document.querySelector('.jfschool > main')
          if (dom) dom.scrollTop = 0
        })
      })
    }
    getCourseDtail()
    function changenode(e: any, data: any) {
      if ((data.node.children || []).length) {
        data.selected = false
        const currenNodeKey = data.node.eventKey
        const expandedKeys = JSON.parse(JSON.stringify(pageData.expandedKeys))
        // 点击整行，展开收起
        if (pageData.expandedKeys.indexOf(currenNodeKey) > -1) {
          expandedKeys.splice(expandedKeys.indexOf(currenNodeKey), 1)
        } else {
          expandedKeys.push(currenNodeKey)
        }
        pageData.expandedKeys = expandedKeys
        return
      }
      if (data.selectedNodes[0].props.lessonNo) {
        pageData.currentLess = data.selectedNodes[0].props
        pageData.lessonNo = pageData.currentLess.lessonNo
      }
      // getVideoUrl(pageData.currentLess)
    }
    function isPlaying(state: boolean) {
      pageData.playing = state
    }
    // 切换清晰度
    function changeDefinition(params: { key: string; currentTime: Date }) {
      const video = pageData.videos.filter((item: any) => {
        item.eventType = 'continuation'
        item.currentTime = params.currentTime
        return item.definitionType === params.key
      })
      pageData.videoInfo = video[0]
    }

    pageData.breadcrunmb = store.state.breadcrumbList

    watch(
      () => [pageData.courseId, pageData.lessonNo],
      (val: any) => {
        if (val[0] || val[1]) {
          getCourseDtail()
        }
      }
    )
    watch(
      () => route.query.theme,
      (val: any) => {
        pageData.theme = val
      }
    )
    return {
      ...toRefs(pageData),
      changenode,
      isPlaying,
      changeDefinition
    }
  }
})
